import { Injectable, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// ── Global service to open/close validation dialog from anywhere ──
@Injectable({ providedIn: 'root' })
export class ValidationDialogService {
  private _state$ = new BehaviorSubject<{ visible: boolean; title: string; message: string; icon: 'error' | 'warning' | 'success' }>({
    visible: false, title: '', message: '', icon: 'error'
  });
  state$ = this._state$.asObservable();

  show(title: string, message: string, icon: 'error' | 'warning' | 'success' = 'error') {
    this._state$.next({ visible: true, title, message, icon });
  }

  close() {
    this._state$.next({ ...this._state$.value, visible: false });
  }
}

// ── Validation Dialog Component ──
@Component({
  selector: 'app-validation-dialog',
  templateUrl: './validation-dialog.component.html'
})
export class ValidationDialogComponent {
  visible = false;
  title = '';
  message = '';
  icon: 'error' | 'warning' | 'success' = 'error';

  constructor(public service: ValidationDialogService) {
    this.service.state$.subscribe(state => {
      this.visible = state.visible;
      this.title = state.title;
      this.message = state.message;
      this.icon = state.icon;
    });
  }

  close() {
    this.service.close();
  }
}
